import axios from 'axios'

const API_URL = process.env.VUE_APP_API_SUPPORT_URL

class SearchService {
  getSerachResult(searchString) {
    return axios.post(API_URL + '/search/global/results', { SearchKey:searchString,Limit:20 })
  }
}

export default new SearchService()
